export default function useHeaderOffset() {
  return 64;
}
